import type { Artwork } from "./types";

export const gifWorks: Artwork[] = [
  {
    id: "g1",
    title: "IMG_0742",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/img-0742.gif",
    fullImage: "/gallery/gif/full/IMG_0742.GIF",
    date: "2026-02-09",
  },
  {
    id: "g2",
    title: "IMG_0817",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/img-0817.gif",
    fullImage: "/gallery/gif/full/IMG_0817.GIF",
    date: "2026-02-09",
  },
  {
    id: "g3",
    title: "IMG_1175",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/img-1175.gif",
    fullImage: "/gallery/gif/full/IMG_1175.GIF",
    date: "2026-02-09",
  },
  {
    id: "g4",
    title: "IMG_1201",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/img-1201.gif",
    fullImage: "/gallery/gif/full/IMG_1201.GIF",
    date: "2026-02-09",
  },
  {
    id: "g5",
    title: "IMG_1219",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/img-1219.gif",
    fullImage: "/gallery/gif/full/IMG_1219.GIF",
    date: "2026-02-09",
  },
  {
    id: "g6",
    title: "IMG_1221",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/img-1221.gif",
    fullImage: "/gallery/gif/full/IMG_1221.GIF",
    date: "2026-02-09",
  },
  {
    id: "g7",
    title: "IMG_1222",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/img-1222.gif",
    fullImage: "/gallery/gif/full/IMG_1222.GIF",
    date: "2026-02-09",
  },
  {
    id: "g8",
    title: "IMG_1270",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/img-1270.gif",
    fullImage: "/gallery/gif/full/IMG_1270.GIF",
    date: "2026-02-09",
  },
  {
    id: "g9",
    title: "IMG_1311",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/img-1311.gif",
    fullImage: "/gallery/gif/full/IMG_1311.GIF",
    date: "2026-02-09",
  },
  {
    id: "g10",
    title: "WigglyPaint_24484159-FBA7-4A63-AAFF-4E580F296BB7",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/wigglypaint-24484159-fba7-4a63-aaff-4e580f296bb7.gif",
    fullImage: "/gallery/gif/full/WigglyPaint_24484159-FBA7-4A63-AAFF-4E580F296BB7.GIF",
    date: "2026-02-09",
  },
  {
    id: "g11",
    title: "WigglyPaint_30F4C6E8-1F10-4190-9F7E-8A13C42E6F91",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/wigglypaint-30f4c6e8-1f10-4190-9f7e-8a13c42e6f91.gif",
    fullImage: "/gallery/gif/full/WigglyPaint_30F4C6E8-1F10-4190-9F7E-8A13C42E6F91.GIF",
    date: "2026-02-09",
  },
  {
    id: "g12",
    title: "WigglyPaint_711F19A7-FDD2-459D-87D3-27DBB1A659C6",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/wigglypaint-711f19a7-fdd2-459d-87d3-27dbb1a659c6.gif",
    fullImage: "/gallery/gif/full/WigglyPaint_711F19A7-FDD2-459D-87D3-27DBB1A659C6.GIF",
    date: "2026-02-09",
  },
  {
    id: "g13",
    title: "WigglyPaint_AB961DC1-B238-4329-8638-942EF4AD619D",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/wigglypaint-ab961dc1-b238-4329-8638-942ef4ad619d.gif",
    fullImage: "/gallery/gif/full/WigglyPaint_AB961DC1-B238-4329-8638-942EF4AD619D.GIF",
    date: "2026-02-09",
  },
  {
    id: "g14",
    title: "WigglyPaint_E140B89F-754A-4D26-99AC-F4AFEB5A24A1",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/wigglypaint-e140b89f-754a-4d26-99ac-f4afeb5a24a1.gif",
    fullImage: "/gallery/gif/full/WigglyPaint_E140B89F-754A-4D26-99AC-F4AFEB5A24A1.GIF",
    date: "2026-02-09",
  },
  {
    id: "g15",
    title: "WigglyPaint_E3AD8643-2639-435F-82C0-ACF0810BF14C",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/wigglypaint-e3ad8643-2639-435f-82c0-acf0810bf14c.gif",
    fullImage: "/gallery/gif/full/WigglyPaint_E3AD8643-2639-435F-82C0-ACF0810BF14C.GIF",
    date: "2026-02-09",
  },
  {
    id: "g16",
    title: "WigglyPaint_EACA6DBB-C1C2-49A5-A0E0-C8F86522D5A3",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/wigglypaint-eaca6dbb-c1c2-49a5-a0e0-c8f86522d5a3.gif",
    fullImage: "/gallery/gif/full/WigglyPaint_EACA6DBB-C1C2-49A5-A0E0-C8F86522D5A3.GIF",
    date: "2026-02-09",
  },
  {
    id: "g17",
    title: "WigglyPaint_EF08E56A-7FA4-4C3A-8177-92337D20815E",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/wigglypaint-ef08e56a-7fa4-4c3a-8177-92337d20815e.gif",
    fullImage: "/gallery/gif/full/WigglyPaint_EF08E56A-7FA4-4C3A-8177-92337D20815E.GIF",
    date: "2026-02-09",
  },
  {
    id: "g18",
    title: "WigglyPaint_F5B526BF-5E59-4A1E-8598-F3C9CF3F58FE",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/wigglypaint-f5b526bf-5e59-4a1e-8598-f3c9cf3f58fe.gif",
    fullImage: "/gallery/gif/full/WigglyPaint_F5B526BF-5E59-4A1E-8598-F3C9CF3F58FE.GIF",
    date: "2026-02-09",
  },
  {
    id: "g19",
    title: "WigglyPaint_F631E116-EE77-4C3B-BC54-7E10CE34B077",
    year: 2026,
    medium: "Animated GIF",
    thumbnail: "/gallery/gif/thumbs/wigglypaint-f631e116-ee77-4c3b-bc54-7e10ce34b077.gif",
    fullImage: "/gallery/gif/full/WigglyPaint_F631E116-EE77-4C3B-BC54-7E10CE34B077.GIF",
    date: "2026-02-09",
  },
];
